import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';
import { EventConfigResponseData } from 'src/app/@data-services/event-config/event-config.data-model';
import { EventConfigStateService } from 'src/app/@store/event-config-state.service';
import { LanguageStore } from 'src/app/@store/language-store';
import { applyDocumentTitle } from 'src/app/@utils/apply-document-title';
import { applyTheme } from 'src/app/@utils/apply-theme';
import { environment } from 'src/environments/environment';

export function appEventConfigInitializer() {
  const http = inject(HttpClient);
  const apiUrl = environment.apiUrl;
  const eventConfigStateService = inject(EventConfigStateService);
  const languageStore = inject(LanguageStore);

  return (): Promise<any> =>
    firstValueFrom(
      http
        .post<EventConfigResponseData>(apiUrl + '/r1/getEventConfig', {
          domain:
            window.location.hostname === 'localhost'
              ? 'dev-sbx.synopsis.rozie.ai'
              : window.location.hostname,
        })
        .pipe(
          map((response) => {
            eventConfigStateService.setEventIdentifier(
              response.data.EventIdentifier
            );
            eventConfigStateService.setEventConfigData(response.data);
            eventConfigStateService.setSponsors(response.data.Sponsors);
            eventConfigStateService.setFeatureConfigData(
              response.data.Features
            );
            languageStore.setAvailableLanguages(
              response.data.SupportedLanguages
            );
            languageStore.setOriginalLanguageCode(
              response.data.OriginalLanguageCode
            );
            applyTheme(response.data.Themes);
            applyDocumentTitle(response.data.Information.EventNameDisplay);
          })
        )
    );
}
